import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import UserService from "services/UserService";
import TextInput from "components/Input/TextInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import {
  IntInput,
} from "components/Input/Index.js";
import DateInput from "components/Input/DateInput.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styled from "styled-components";
import { postTertiaryBill } from "services/ConfigServices";
import { NotificationManager } from "react-notifications";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import EditButton from "components/CustomButtons/Button.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import Dialog from "@mui/material/Dialog";
import { declapage, declaconsobycategory } from "variables/tertiaryBill";
import DataTable from "react-data-table-component";
import moment from "moment";
import { categorypage } from "variables/tertiaryBill";
import CategoryEditionDialog from "./CategoryEditionDialog";
import { patrimoinepage } from "variables/tertiaryBill";
import { weatherstations } from "variables/lists/tertiarybill";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import HelpIcon from '@mui/icons-material/Help';
import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import CustomConfirmationButton from "components/CustomButtons/CustomConfirmationButton.js";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    width: "40ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonWarning: {
    color: "#FFFFFF",
    backgroundColor: "#FF763A",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    width: "40ch",
    "&:hover": {
      backgroundColor: "#FF763A",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    width: "40ch",
  },
  pageButton: {
    color: "#FFFFFF",
    backgroundColor: "#3E8FC6",
    fontWeight: "bold",
    fontSize: "12px",
    display: "block",
    marginTop: "6px",
    width: "40ch",
    "&:hover": {
      backgroundColor: "#3E8FC6",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  pageButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    fontSize: "12px",
    display: "block",
    marginTop: "6px",
    width: "40ch",
  },
  getdataButton: {
    color: "#FFFFFF",
    backgroundColor: "#3E8FC6",
    fontWeight: "bold",
    fontSize: "12px",
    display: "block",
    marginTop: "15px",
    marginLeft: "8px",
    width: "40ch",
    "&:hover": {
      backgroundColor: "#3E8FC6",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  getdataButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    fontSize: "12px",
    display: "block",
    marginTop: "15px",
    marginLeft: "8px",
    width: "40ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  icon: {
    left: "5px",
    top: "30px",
    width: "22px",
    height: "22px",
    position: "relative",
    verticalAlign: "middle",
    cursor: "pointer",
    color: "#3E8FC6",
  },
}));
const Container = styled.div`
  border: solid;
  border-width: 1px;
  border-color: #EEEEEE;
  background-color: white;
  margin-top: -0.5px;
  padding-top: 5px;
  overflow-x: auto;
  width: 100%;
`;
const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const ButtonsDiv = styled.div`
  display: flex;
  padding-left: 22px;
  padding-right: 22px;
  margin-top: 15px;
  justify-content: space-between;
`;

const Page = styled.div`

`;
const HelpLineMeter = styled.p`
  margin-top: 10px;
  text-align : left;
`;

const HelpLine = styled.p`
  text-align : left;
`;


const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles2 = makeStyles(styles);

function DeclarationDialog(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupAccountListById } = appContext;

  const sweetClasse = UseSweetAlertStyle();
  const classes2 = useStyles2();
  const { closeModal, refetch, tertiarybill, currentyear, declaration, consocategorydata } = props;

  const [page, setPage] = useState(1);

  const [idefaoperat, setIdefaoperat] = useState(tertiarybill?.idefaoperat || "");
  const [maincategory, setMaincategory] = useState(tertiarybill?.maincategory || "");
  const [weatherstation, setWeatherstation] = useState(tertiarybill?.weatherstation || "");
  const [categories, setCategories] = useState(tertiarybill?.categories || [])
  const [selectedCategories, setSelectedCategories] = useState(tertiarybill?.categories || []);
  const [currentCategory, setCurrentCategory] = useState("");
  const [opencategory, setOpencategory] = useState(false);
  const [maincategorydata, setMaincategorydata] = useState([]);
  const [evcount, setEvcount] = useState(tertiarybill?.evcount || "");

  const [consocategory, setConsocategory] = useState("indi");
  const [electricityconsumptionvar, setelectricityconsumptionvar] = useState("consoIndiHorsIRVEKWh");
  const [gasconsumptionvar, setgasconsumptionvar] = useState("consoIndiGazNatReseauxKWh");
  const [liquidgasconsumptionvar, setliquidgasconsumptionvar] = useState("consoIndiGazNatLiquefieKg");
  const [propanem3consumptionvar, setpropanem3consumptionvar] = useState("consoIndiGazPropaneM3");
  const [propanekgconsumptionvar, setpropanekgconsumptionvar] = useState("consoIndiGazPropaneKg");
  const [butanem3consumptionvar, setbutanem3consumptionvar] = useState("consoIndiGazButaneM3");
  const [butanekgconsumptionvar, setbutanekgconsumptionvar] = useState("consoIndiGazButaneKg");
  const [fuelconsumptionvar, setfuelconsumptionvar] = useState("consoIndiFioulDomestiLitre");
  const [coalconsumptionvar, setcoalconsumptionvar] = useState("consoIndiCharbonAggloBriqKg");
  const [houilleconsumptionvar, sethouilleconsumptionvar] = useState("consoIndiHouilleKg");
  const [industrywoodconsumptionvar, setindustrywoodconsumptionvar] = useState("consoIndiBoisPlaqIndustrieKg");
  const [forestwoodconsumptionvar, setforestwoodconsumptionvar] = useState("consoIndiBoisPlaqForestKg");
  const [granulewoodconsumptionvar, setgranulewoodconsumptionvar] = useState("consoIndiBoisGranBriqKg");
  const [logwoodconsumptionvar, setlogwoodconsumptionvar] = useState("consoIndiBoisBuchesStere");
  const [heatnetworkconsumptionvar, setheatnetworkconsumptionvar] = useState("consoIndiReseauChaleurKWh");
  const [coldnetworkconsumptionvar, setcoldnetworkconsumptionvar] = useState("consoIndiReseauFroidKWh");

  const [declarationtosend, setDecalarationtosend] = useState({});
  const [tooltips, setTooltips] = useState({})


  const [alert, setAlert] = React.useState(null);


  const [sendButtonStatus, setSendButtonStatus] = useState(0);
  const [nextpagebuttonDisabled, setNextpagebuttonDisabled] = useState(true);
  const [getdatabuttonDisabled, setGetdatabuttonDisabled] = useState(false);
  const classes = useStyles();

  const handleDeclarationChange = (event, key) => {
    let newdeclaration = { ...declarationtosend };
    newdeclaration[key] = event.target.value;
    setDecalarationtosend(newdeclaration);
  };
  const handleConsocategoryChange = (event) => {
    setConsocategory(event.target.value);
    setelectricityconsumptionvar(declaconsobycategory[event.target.value].electricityconsumption);
    setgasconsumptionvar(declaconsobycategory[event.target.value].gasconsumption);
    setliquidgasconsumptionvar(declaconsobycategory[event.target.value].liquidgasconsumption);
    setpropanem3consumptionvar(declaconsobycategory[event.target.value].propanem3consumption);
    setpropanekgconsumptionvar(declaconsobycategory[event.target.value].propanekgconsumption);
    setbutanem3consumptionvar(declaconsobycategory[event.target.value].butanem3consumption);
    setbutanekgconsumptionvar(declaconsobycategory[event.target.value].butanekgconsumption);
    setfuelconsumptionvar(declaconsobycategory[event.target.value].fuelconsumption);
    setcoalconsumptionvar(declaconsobycategory[event.target.value].coalconsumption);
    sethouilleconsumptionvar(declaconsobycategory[event.target.value].houilleconsumption);
    setindustrywoodconsumptionvar(declaconsobycategory[event.target.value].industrywoodconsumption);
    setforestwoodconsumptionvar(declaconsobycategory[event.target.value].forestwoodconsumption);
    setgranulewoodconsumptionvar(declaconsobycategory[event.target.value].granulewoodconsumption);
    setlogwoodconsumptionvar(declaconsobycategory[event.target.value].logwoodconsumption);
    setheatnetworkconsumptionvar(declaconsobycategory[event.target.value].heatnetworkconsumption);
    setcoldnetworkconsumptionvar(declaconsobycategory[event.target.value].coldnetworkconsumption);
  };



  useEffect(() => {
    let categoriestmp = [...tertiarybill?.categories];
    categoriestmp.forEach((cat) => {
      if (currentyear === 'REFERENCE') {
        if (declarationtosend && declarationtosend.startdate) {
          cat.datebegin = declarationtosend.startdate + "-01";
          cat.dateend = moment(declarationtosend.startdate).add(12, 'month').add(-1, 'day').format('YYYY-MM-DD');
        }
        else {
          cat.datebegin = '';
          cat.dateend = '';
        }
      }
      else {
        cat.datebegin = currentyear + "-01-01";
        cat.dateend = currentyear + "-12-31";
      }
    });

  }, [declarationtosend?.startdate]);

  // useEffect(() => {
  //   let newdeclaration = { ...declaration };
  //   setDecalarationtosend(newdeclaration);
  // }, [declaration]);

  useEffect(() => {
    let disabled = true;
    if (declarationtosend && selectedCategories.length > 0 &&
      (currentyear !== 'REFERENCE' || declarationtosend.startdate) &&
      idefaoperat && maincategory) {
      disabled = false;
    }
    setNextpagebuttonDisabled(disabled);
  }, [selectedCategories, declarationtosend, currentyear, idefaoperat, maincategory]);

  useEffect(() => {
    let catdatatmp = [];
    selectedCategories.forEach((category) => {
      if (!catdatatmp.find((data) => data.id === category.category))
        catdatatmp.push({ id: category.category, name: category.category });
    });
    setMaincategorydata(catdatatmp);
  }, [selectedCategories]);

  useEffect(() => {
    let status = 0;
    let ok = 0;
    let ko = 0;
    if (tertiarybill && declarationtosend) {
      if (tertiarybill.consoelec)
        (declarationtosend.consoIndiHorsIRVEKWh !== undefined && declarationtosend.consoIndiHorsIRVEKWh.length !== 0) ? ok++ : ko++;
      if (tertiarybill.consogaznatreseau)
        (declarationtosend.consoIndiGazNatReseauxKWh !== undefined && declarationtosend.consoIndiGazNatReseauxKWh.length !== 0) ? ok++ : ko++;
      if (tertiarybill.consogaznatliq)
        (declarationtosend.consoIndiGazNatLiquefieKg !== undefined && declarationtosend.consoIndiGazNatLiquefieKg.length !== 0) ? ok++ : ko++;
      if (tertiarybill.consogazprop)
        ((declarationtosend.consoIndiGazPropaneM3 !== undefined && declarationtosend.consoIndiGazPropaneM3.length !== 0) ||
          (declarationtosend.consoIndiGazPropaneKg !== undefined && declarationtosend.consoIndiGazPropaneKg.length !== 0)) ? ok++ : ko++;
      if (tertiarybill.consogazbut)
        ((declarationtosend.consoIndiGazButaneM3 !== undefined && declarationtosend.consoIndiGazButaneM3.length !== 0) ||
          (declarationtosend.consoIndiGazButaneKg !== undefined && declarationtosend.consoIndiGazButaneKg.length !== 0)) ? ok++ : ko++;
      if (tertiarybill.consofiouldom)
        (declarationtosend.consoIndiFioulDomestiLitre !== undefined && declarationtosend.consoIndiFioulDomestiLitre.length !== 0) ? ok++ : ko++;
      if (tertiarybill.consocharbonagglo)
        (declarationtosend.consoIndiCharbonAggloBriqKg !== undefined && declarationtosend.consoIndiCharbonAggloBriqKg.length !== 0) ? ok++ : ko++;
      if (tertiarybill.consohouille)
        (declarationtosend.consoIndiHouilleKg !== undefined && declarationtosend.consoIndiHouilleKg.length !== 0) ? ok++ : ko++;
      if (tertiarybill.consoboisplaqind)
        (declarationtosend.consoIndiBoisPlaqIndustrieKg !== undefined && declarationtosend.consoIndiBoisPlaqIndustrieKg.length !== 0) ? ok++ : ko++;
      if (tertiarybill.consoboisplaqfor)
        (declarationtosend.consoIndiBoisPlaqForestKg !== undefined && declarationtosend.consoIndiBoisPlaqForestKg.length !== 0) ? ok++ : ko++;
      if (tertiarybill.consoboisgran)
        (declarationtosend.consoIndiBoisGranBriqKg !== undefined && declarationtosend.consoIndiBoisGranBriqKg.length !== 0) ? ok++ : ko++;
      if (tertiarybill.consoboisbuche)
        (declarationtosend.consoIndiBoisBuchesStere !== undefined && declarationtosend.consoIndiBoisBuchesStere.length !== 0) ? ok++ : ko++;
      if (tertiarybill.consoreseauchal)
        (declarationtosend.consoIndiReseauChaleurKWh !== undefined && declarationtosend.consoIndiReseauChaleurKWh.length !== 0) ? ok++ : ko++;
      if (tertiarybill.consoreseaufrois)
        (declarationtosend.consoIndiReseauFroidKWh !== undefined && declarationtosend.consoIndiReseauFroidKWh.length !== 0) ? ok++ : ko++;
      if (ok > 0 && ko > 0)
        status = 1;
      else if (ok > 0 && ko === 0)
        status = 2;
    }
    setSendButtonStatus(status);
  }, [declarationtosend, tertiarybill]);


  /**PAGE 1 */

  const handleIdefaoperatChange = (event) => {
    setIdefaoperat(event.target.value);
  };
  const handleMaincategoryChange = (event) => {
    setMaincategory(event.target.value);
  };
  const handleWeatherstationChange = (event) => {
    setWeatherstation(event.target.value);
  };
  const handleEvcountChange = (event) => {
    setEvcount(event.target.value);
  };

  const handleClickOpenCategory = () => {
    setOpencategory(true);
  };
  const handleClickCloseCategory = () => {
    setOpencategory(false);
  };

  const editCategory = (row) => async () => {
    let obj = categories.find((o) => o.uuid === row.uuid);
    if (obj) {
      setCurrentCategory(obj);
      handleClickOpenCategory();
    }
  }
  const handleEditCategories = () => {

  }

  const indicatorscolumns = [
    {
      name: categorypage.indicatorname,
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => row.name
    },
    {
      name: categorypage.indicatorvalue,
      selector: (row) => row.value,
      sortable: true,
      cell: (row) => row.value
    }
  ]
  const categoriescolumns = [
    {
      name: categorypage.category,
      selector: (row) => row.category,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.category || ""
    },
    {
      name: categorypage.subcategory,
      selector: (row) => row.subcategory,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.subcategory || ""
    },
    {
      name: categorypage.surface,
      selector: (row) => row.surface,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.surface
    },
    {
      name: categorypage.datebegin,
      selector: (row) => row.datebegin,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        row.datebegin && moment(row.datebegin).isValid()
          ? moment(row.datebegin).format("DD/MM/YYYY")
          : "",
    },
    {
      name: categorypage.dateend,
      selector: (row) => row.dateend,
      sortable: true,
      cell: (row) =>
        row.dateend && moment(row.dateend).isValid()
          ? moment(row.dateend).format("DD/MM/YYYY")
          : "",
    },
    {
      name: "",
      sortable: false,
      width: "8rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title={categorypage.editcategory}>
              <EditButton
                onClick={editCategory(row)}
                color={"warning"}
                className={classes2.actionButtonDense}
              >
                <EditIcon fontSize="large" />
              </EditButton>
            </Tooltip>
          </div>
        </>
      ),
    },
  ]
  const ExpandableComponent = props => {
    const { data } = props;
    const datadisplay = data.indicators;

    return (
      <Container>
        <ExpandableContainer>
          <ExpandableElement>
            <ElementTitle>{categorypage.heating} : </ElementTitle>
            <ElementData>{data.heating ? 'Oui' : 'Non'}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{categorypage.cooling} : </ElementTitle>
            <ElementData>{data.cooling ? 'Oui' : 'Non'}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{categorypage.coollog} : </ElementTitle>
            <ElementData>{data.coollog ? 'Oui' : 'Non'}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{categorypage.coolcom} : </ElementTitle>
            <ElementData>{data.coolcom ? 'Oui' : 'Non'}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{categorypage.consdoc} : </ElementTitle>
            <ElementData>{data.consdoc ? 'Oui' : 'Non'}</ElementData>
          </ExpandableElement>
        </ExpandableContainer>
        <DataTable
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          noDataComponent={<NoData>Aucun indicateur à afficher</NoData>}
          noHeader={true}
          columns={indicatorscolumns}
          persistTableHead
          data={datadisplay}
          striped={true}
          dense
        />
      </Container>
    );
  };

  let isInitialized = false;
  const handleSelectedRowsChange = state => {
    if (state.selectedRows.length === selectedCategories.length) {
      isInitialized = true;
    }
    if (isInitialized === true && state.selectedRows.length !== selectedCategories.length)
      setSelectedCategories(state.selectedRows);
  };


  const defaultSelectedRows = (row) => selectedCategories.some((eq) => eq.id == row.id);
  /**END PAGE 1 */


  /** PAGE 2 */

  const handleSubmit = async (event) => {
    let decla = {
      account: groupAccountListById["" + chartIdGroup],
      declaration: declarationtosend,
      year: currentyear,
      idefaoperat: idefaoperat,
      weatherstation: weatherstation,
      categories: categories,
      maincategory: maincategory,
      vehiElecNbBornes: evcount,
    }
    axios
      .post(
        postTertiaryBill("declaration"),
        decla
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success(declapage.declarationsend);
          refetch();
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const handleGetData = async (event) => {
    setGetdatabuttonDisabled(true);
    let data = [];
    if (tertiarybill.consoelec)
      data.push("consoelec");
    if (tertiarybill.consogaznatreseau)
      data.push("consogaznatreseau");
    if (tertiarybill.consogazprop)
      data.push("consogazprop");
    if (tertiarybill.consofiouldom)
      data.push("consofiouldom");
    if (tertiarybill.consoreseauchal)
      data.push("consoreseauchal");
    if (tertiarybill.consoreseaufrois)
      data.push("consoreseaufrois");
    let dataquery = {
      groupid: chartIdGroup[0],
      account: groupAccountListById["" + chartIdGroup],
      data: data,
      year: currentyear,
      startdate: declarationtosend?.startdate,
    }
    axios
      .post(
        postTertiaryBill("getavobdata"),
        dataquery
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        setGetdatabuttonDisabled(false);
        if (res.status == 200) {
          let newdeclaration = { ...declarationtosend };
          let tooltipstmp = {};
          if (tertiarybill.consoelec) {
            if (res.data.consoelec.meterresults) {
              newdeclaration[electricityconsumptionvar] = res.data.consoelec.val;
              tooltipstmp[electricityconsumptionvar] = res.data.consoelec.meterresults;
            }
          }
          if (tertiarybill.consogaznatreseau) {
            if (res.data.consogaznatreseau.meterresults) {
              newdeclaration[gasconsumptionvar] = res.data.consogaznatreseau.val;
              tooltipstmp[gasconsumptionvar] = res.data.consogaznatreseau.meterresults;
            }
          }
          if (tertiarybill.consogazprop) {
            if (res.data.consogazprop.meterresults) {
              newdeclaration[propanekgconsumptionvar] = res.data.consogazprop.val;
              tooltipstmp[propanekgconsumptionvar] = res.data.consogazprop.meterresults;
            }
          }
          if (tertiarybill.consofiouldom) {
            if (res.data.consofiouldom.meterresults) {
              newdeclaration[fuelconsumptionvar] = res.data.consofiouldom.val;
              tooltipstmp[fuelconsumptionvar] = res.data.consofiouldom.meterresults;
            }
          }
          if (tertiarybill.consoreseauchal) {
            if (res.data.consoreseauchal.meterresults) {
              newdeclaration[heatnetworkconsumptionvar] = res.data.consoreseauchal.val;
              tooltipstmp[heatnetworkconsumptionvar] = res.data.consoreseauchal.meterresults;
            }
          }
          if (tertiarybill.consoreseaufrois && res.data.consoreseaufrois) {
            if (res.data.consoreseaufrois.meterresults) {
              newdeclaration[coldnetworkconsumptionvar] = res.data.consoreseaufrois.val;
              tooltipstmp[coldnetworkconsumptionvar] = res.data.consoreseaufrois.meterresults;
            }
          }
          setTooltips(tooltipstmp);
          setDecalarationtosend(newdeclaration);
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
      });
  }

  const hideAlert = () => {
    setAlert(null);
  };

  const getTooltipHelp = (indic) => {
    const tooltipAlert = (
      <SweetAlert
        style={{
          fontSize: '14px',
          fontFamily: '"Source Sans Pro",sans-serif',
          color: ' #3c4858',
          display: "block", marginTop: "-50px", width: "25rem"
        }}
        title=""
        showConfirm={false}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={sweetClasse.button + " " + sweetClasse.info}
      >
        <div style={{ fontSize: "14px" }}>
          {
            tooltips[indic] ?
              tooltips[indic].map((meter) => {
                return (
                  <>
                    <HelpLineMeter>{meter.meter}</HelpLineMeter>
                    <HelpLine>{declapage.nodataday + (meter.totalday - meter.totaldaywithdata)}</HelpLine>
                    <HelpLine>{declapage.multipledataday + (meter.totaldaywithmultipledata)}</HelpLine>
                    <HelpLine>{declapage.metertotal + (meter.metertotal)}</HelpLine>
                  </>
                );
              })
              : <HelpLineMeter>{declapage.noavobdata}</HelpLineMeter>
          }
        </div>
      </SweetAlert>
    );
    setAlert(tooltipAlert);
  };

  /**END PAGE 2 */

  return (
    <>

      <form className={classes.root}>

        {/* <div>
              <CustomSelect
                inputTitle={declapage.yearchoice}
                selectValue={year}
                handleSelectValueChange={handleYearChange}
                data={yeardata}
              />
            </div> */}

        <Page style={{ display: page === 1 ? "block" : "none" }}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              {
                currentyear === 'REFERENCE' ?
                  <div>
                    <DateInput
                      inputTitle={declapage.startdate}
                      dateInput={declarationtosend?.startdate || ''}
                      handleDateInputChange={(event) => handleDeclarationChange(event, 'startdate')}
                      specialType={"month"}
                      disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                    />
                  </div>
                  : <></>
              }
              <div>
                <TextInput
                  inputTitle={patrimoinepage.idefaoperat}
                  textInput={idefaoperat}
                  handleTextInputChange={handleIdefaoperatChange}
                  disabled={!realestateupdate}
                />
              </div>
              <div>
                <CustomSelect
                  inputTitle={patrimoinepage.weatherstation}
                  selectValue={weatherstation}
                  handleSelectValueChange={handleWeatherstationChange}
                  disabled={!realestateupdate}
                  data={weatherstations}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                <DataTable
                  paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                  noDataComponent={<NoData>{"Aucune catégorie"}</NoData>}
                  noHeader={true}
                  columns={categoriescolumns}
                  pagination
                  data={categories}
                  paginationComponentOptions={{
                    noRowsPerPage: true,
                    rowsPerPageText: "Lignes par page",
                    rangeSeparatorText: "sur",
                    selectAllRowsItem: false,
                    selectAllRowsItemText: "Selectionner toutes les lignes",
                  }}
                  defaultPageSize={10}
                  dense
                  defaultSortFieldId={1}
                  manual={true}
                  onSelectedRowsChange={handleSelectedRowsChange}
                  selectableRowSelected={defaultSelectedRows}
                  selectableRows={true}
                  selectableRowsNoSelectAll={true}
                  expandOnRowClicked
                  expandableRows
                  expandableRowDisabled={(row) => row.disabled}
                  expandableRowsComponent={ExpandableComponent}
                />
              </div>
              <div>
                <CustomSelect
                  inputTitle={patrimoinepage.maincategory}
                  selectValue={maincategory}
                  handleSelectValueChange={handleMaincategoryChange}
                  disabled={!realestateupdate || (maincategorydata.length === 0)}
                  data={maincategorydata}
                />
              </div>
              <div>
                <IntInput
                  inputTitle={patrimoinepage.evcount}
                  intInput={evcount}
                  handleIntInputChange={handleEvcountChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
          </GridContainer>
          <ButtonsDiv style={{ flexDirection: "row-reverse" }}>
            <Button
              disabled={nextpagebuttonDisabled}
              className={
                nextpagebuttonDisabled
                  ? classes.pageButtonDisabled
                  : classes.pageButton
              }
              onClick={() => {
                setPage(2);
              }}
            >
              {declapage.buttonnextpage}
            </Button>
          </ButtonsDiv>
        </Page>

        <Page style={{ display: page === 2 ? "block" : "none" }}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <GridContainer>
                {
                  evcount > 0 &&

                  <GridItem xs={12} sm={12} md={9} lg={9}>
                    <div>
                      <IntInput
                        inputTitle={declapage.vehiElecConsoAvcIRVEKWh}
                        intInput={declarationtosend?.vehiElecConsoAvcIRVEKWh || ''}
                        handleIntInputChange={(event) => handleDeclarationChange(event, 'vehiElecConsoAvcIRVEKWh')}
                        disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                      />
                    </div>
                  </GridItem>
                }
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={9} lg={9}>
                  <div>
                    <CustomSelect
                      inputTitle={declapage.consocategory}
                      selectValue={consocategory}
                      handleSelectValueChange={handleConsocategoryChange}
                      data={consocategorydata}
                      disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                    />
                  </div>
                </GridItem>
              </GridContainer>
              {
                consocategory === 'froidLogist' ?
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      <div>
                        <IntInput
                          inputTitle={declapage.froidLogistHauteurRefroidie}
                          intInput={declarationtosend ? declarationtosend.froidLogistHauteurRefroidie || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, declarationtosend.froidLogistHauteurRefroidie)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                    </GridItem>
                  </GridContainer>
                  : <></>
              }
              {
                consocategory === 'indi' &&
                <>
                  <Button
                    disabled={getdatabuttonDisabled}
                    className={
                      getdatabuttonDisabled
                        ? classes.getdataButtonDisabled
                        : classes.getdataButton
                    }
                    onClick={() => {
                      handleGetData();
                    }}
                  >
                    {declapage.buttongetconsumptionfromavob}
                  </Button>
                </>
              }
              {
                tertiarybill.consoelec ?
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      <div>
                        <IntInput
                          inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.electricityconsumption}
                          intInput={declarationtosend ? declarationtosend[electricityconsumptionvar] || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, electricityconsumptionvar)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3} lg={3}>
                      <HelpIcon className={classes.icon} onClick={() => getTooltipHelp(electricityconsumptionvar)} />
                    </GridItem>
                  </GridContainer>
                  : <></>
              }
              {
                tertiarybill.consogaznatreseau ?
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      <div>
                        <IntInput
                          inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.gasconsumption}
                          intInput={declarationtosend ? declarationtosend[gasconsumptionvar] || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, gasconsumptionvar)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3} lg={3}>
                      <HelpIcon className={classes.icon} onClick={() => getTooltipHelp(gasconsumptionvar)} />
                    </GridItem>
                  </GridContainer> : <></>
              }
              {
                tertiarybill.consogaznatliq ?
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      <div>
                        <IntInput
                          inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.liquidgasconsumption}
                          intInput={declarationtosend ? declarationtosend[liquidgasconsumptionvar] || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, liquidgasconsumptionvar)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                    </GridItem>
                  </GridContainer> : <></>
              }
              {
                tertiarybill.consogazprop ?
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      <div>
                        <IntInput
                          inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.propanem3consumption}
                          intInput={declarationtosend ? declarationtosend[propanem3consumptionvar] || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, propanem3consumptionvar)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                      <div>
                        <IntInput
                          inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.propanekgconsumption}
                          intInput={declarationtosend ? declarationtosend[propanekgconsumptionvar] || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, propanekgconsumptionvar)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3} lg={3}>
                      <HelpIcon className={classes.icon} onClick={() => getTooltipHelp(propanekgconsumptionvar)} />
                    </GridItem>
                  </GridContainer> : <></>
              }
              {
                tertiarybill.consogazbut ?
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      <div>
                        <IntInput
                          inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.butanem3consumption}
                          intInput={declarationtosend ? declarationtosend[butanem3consumptionvar] || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, butanem3consumptionvar)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                      <div>
                        <IntInput
                          inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.butanekgconsumption}
                          intInput={declarationtosend ? declarationtosend[butanekgconsumptionvar] || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, butanekgconsumptionvar)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                    </GridItem>
                  </GridContainer> : <></>
              }
              {
                tertiarybill.consofiouldom ?
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      <div>
                        <IntInput
                          inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.fuelconsumption}
                          intInput={declarationtosend ? declarationtosend[fuelconsumptionvar] || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, fuelconsumptionvar)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3} lg={3}>
                      <HelpIcon className={classes.icon} onClick={() => getTooltipHelp(fuelconsumptionvar)} />
                    </GridItem>
                  </GridContainer> : <></>
              }
              {
                tertiarybill.consocharbonagglo ?
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      <div>
                        <IntInput
                          inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.coalconsumption}
                          intInput={declarationtosend ? declarationtosend[coalconsumptionvar] || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, coalconsumptionvar)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                    </GridItem>
                  </GridContainer> : <></>
              }
              {
                tertiarybill.consohouille ?
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      <div>
                        <IntInput
                          inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.houilleconsumption}
                          intInput={declarationtosend ? declarationtosend[houilleconsumptionvar] || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, houilleconsumptionvar)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                    </GridItem>
                  </GridContainer> : <></>
              }
              {
                tertiarybill.consoboisplaqind ?
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      <div>
                        <IntInput
                          inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.industrywoodconsumption}
                          intInput={declarationtosend ? declarationtosend[industrywoodconsumptionvar] || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, industrywoodconsumptionvar)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                    </GridItem>
                  </GridContainer> : <></>
              }
              {
                tertiarybill.consoboisplaqfor ?
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      <div>
                        <IntInput
                          inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.forestwoodconsumption}
                          intInput={declarationtosend ? declarationtosend[forestwoodconsumptionvar] || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, forestwoodconsumptionvar)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                    </GridItem>
                  </GridContainer> : <></>
              }
              {
                tertiarybill.consoboisgran ?
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      <div>
                        <IntInput
                          inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.granulewoodconsumption}
                          intInput={declarationtosend ? declarationtosend[granulewoodconsumptionvar] || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, granulewoodconsumptionvar)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                    </GridItem>
                  </GridContainer> : <></>
              }
              {
                tertiarybill.consoboisbuche ?
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      <div>
                        <IntInput
                          inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.logwoodconsumption}
                          intInput={declarationtosend ? declarationtosend[logwoodconsumptionvar] || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, logwoodconsumptionvar)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                    </GridItem>
                  </GridContainer> : <></>
              }
              {
                tertiarybill.consoreseauchal ?
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      <div>
                        <IntInput
                          inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.heatnetworkconsumption}
                          intInput={declarationtosend ? declarationtosend[heatnetworkconsumptionvar] || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, heatnetworkconsumptionvar)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3} lg={3}>
                      <HelpIcon className={classes.icon} onClick={() => getTooltipHelp(heatnetworkconsumptionvar)} />
                    </GridItem>
                  </GridContainer> : <></>
              }
              {
                tertiarybill.consoreseaufrois ?
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={9} lg={9}>
                      <div>
                        <IntInput
                          inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.coldnetworkconsumption}
                          intInput={declarationtosend ? declarationtosend[coldnetworkconsumptionvar] || '' : ''}
                          handleIntInputChange={(event) => handleDeclarationChange(event, coldnetworkconsumptionvar)}
                          disabled={!realestateupdate || declarationtosend?.declaredonOperat}
                        />
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3} lg={3}>
                      <HelpIcon className={classes.icon} onClick={() => getTooltipHelp(coldnetworkconsumptionvar)} />
                    </GridItem>
                  </GridContainer> : <></>
              }
            </GridItem>
          </GridContainer>
          <ButtonsDiv>
            <Button
              className={classes.pageButton}
              onClick={() => {
                setPage(1);
              }}
            >
              Page précédente
            </Button>
            <CustomConfirmationButton
              disabled={sendButtonStatus === 0}
              padding={"0 10px"}
              width={"267px"}
              height={"35px"}
              className={
                (sendButtonStatus === 0)
                  ? classes.submitButtonDisabled
                  : (sendButtonStatus === 1) ? classes.submitButtonWarning
                    : classes.submitButton
              }
              title={declapage.send}
              dialogtitle={declapage.sendtitle}
              subTitle={declapage.confirmsend + (sendButtonStatus === 1 ? declapage.wariningsend : "")}
              confirmation={declapage.yes}
              // icon={<GetAppIcon fontSize="large" />}
              tooltip={declapage.sendtitle}
              color="warning"
              handleConfirmation={() => {
                handleSubmit();
              }}
            />
          </ButtonsDiv>
        </Page>
        {alert}
      </form>
      <Dialog
        onClose={handleClickCloseCategory}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={opencategory}
      >
        <CategoryEditionDialog
          currentCategory={currentCategory}
          closeModal={handleClickCloseCategory}
          categories={categories}
          setCategories={setCategories}
          handleEdit={handleEditCategories}
        // refetch={refreshTableView}
        />
      </Dialog>
    </>
  );
}

export default DeclarationDialog;
